<template>
  <div
    class="flex flex-col"
    :class="showRestOfHome ? 'min-h-screen' : 'h-screen overflow-hidden'"
  >
    <main
      class="relative flex min-h-0 flex-col shrink-0"
      :class="!showRestOfHome ? 'h-screen overflow-hidden' : 'grow'"
    >
      <div class="relative z-10 shrink-0">
        <Header />
      </div>
      <HomeLandingHero />
      <!-- <div class="relative mx-auto max-w-screen-2xl px-4 sm:px-6">
        <div class="flex flex-col items-center py-20 xl:py-30">
          <div class="text-center max-w-111 mb-20 xl:mb-30">
            <h1 class="text-hero text-main font-poppins font-extrabold text-center mb-4">
              {{ $t('home.partner.title') }}
            </h1>
            <p class="text-center">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nulla eligendi sed nisi
              explicabo labore cupiditate quo, voluptate est earum quas dolores .
            </p>
          </div>

          <div
            class="grid grid-cols-4 md:grid-cols-8 gap-x-8 gap-y-10 items-center justify-items-center px-8"
          >
            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 1.png"
                alt="expertise-france"
            /></a>

            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 2.png"
                alt="expertise-france"
            /></a>

            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 3.png"
                alt="expertise-france"
            /></a>

            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 4.png"
                alt="expertise-france"
            /></a>

            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 5.png"
                alt="expertise-france"
            /></a>

            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 1.png"
                alt="expertise-france"
            /></a>

            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 2.png"
                alt="expertise-france"
            /></a>

            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 3.png"
                alt="expertise-france"
            /></a>
            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 1.png"
                alt="expertise-france"
            /></a>

            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 2.png"
                alt="expertise-france"
            /></a>

            <a href="#" target="_blank">
              <img
                class="objet-fill"
                loading="lazy"
                src="../../assets/images/logo 3.png"
                alt="expertise-france"
            /></a>
          </div>
        </div>
        <HomeContact />
      </div> -->
      <!-- <Footer /> -->
      <template v-if="!showRestOfHome">
      <HomeHighlights />
      <HomeKpis />
      <HomeNews />
      <HomeEvents />

      <div class="homePartner relative overflow-hidden h-71 bg-[#F8F8F8F7]/50 pt-15 md:pt-19 mt-10">
        <div class="mx-auto max-w-screen-2xl px-4 sm:px-6 flex justify-between">
          <div class="h-full my-auto">
            <div class="mb-3.5 flex gap-2 *:w-10 *:object-fit">
              <img src="../../assets/images/logo 2.png" alt="logo-cameroun" />
              <img src="../../assets/images/logo 3.png" alt="logo-cameroun" />
            </div>
            <div class="max-w-77 text-xs">
              Lorem ipsum dolor sit amet consectetur, adipisicing elit. Nobis quidem mollitia
              officia sapiente, laudantium asperiores commodi officiis maxime ipsa delectus
              accusantium, saepe ab esse aspernatur non obcaecati. Enim, cupiditate repellat!
            </div>
          </div>
          <div class="flex gap-1 *:mr-2 md:*:mr-7 *:font-extrabold *font:poppins *:text-xl">
            <div>Follow us</div>
            <div>Contact us</div>
          </div>
        </div>
      </div>
      </template>
    </main>
  </div>
</template>

<script setup lang="ts">
import Header from '@/components/layout/Header.vue'
// import Footer from '@/components/layout/Footer.vue'
import HomeLandingHero from './components/HomeLandingHero.vue'
import HomeHighlights from './components/HomeHighlights.vue'
// import HomeContact from './components/HomeContact.vue'
import HomeKpis from './components/HomeKpis.vue'
import HomeNews from './components/HomeNews.vue'
import HomeEvents from './components/HomeEvents.vue'

/** Set to true to show Highlights, KPIs, News, Events, partners, Contact, Footer again. */
const showRestOfHome = true
</script>
<style $scoped>
.homePartner::before {
  content: '';
  position: absolute;
  background: url('../../assets/images/bg_contact_us.png') center;
  opacity: 3%;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: -1;

}
</style>
